import { PolicySettingsAll } from '../../types/types';
import { OpenOptions } from '../../config/openOptions';

export enum Operations {
    open = 'open',
    login = 'login',
    download = 'download',
    upload = 'upload',
    export = 'export',
    signup = 'signup',
    logout = 'logout',
    create = 'create',
    delete = 'delete',
    edit = 'edit',
    permissionsadded = 'permissionsadded',
    createpolicy = 'createpolicy',
    setpolicy = 'setpolicy',
    editpolicy = 'editpolicy',
    permissionsremoved = 'permissionsremoved',
    deleteuser = 'deleteuser',
    sharingrequestblocked = 'sharingrequestblocked',
    accessdenied = 'accessdenied',
    sharingrequestapproved = 'sharingrequestapproved',
    modifyuserrole = 'modifyuserrole',
    userinvite = 'userinvite',
    useradded = 'useradded',
    loginfailed = 'loginfailed',
    otpfailed = 'otpfailed',
    possibleleak = 'possibleleak',
    filerequest = 'filerequest',
    blocked = 'blocked',
    adduserstogroup = 'adduserstogroup',
    removeusersfromgroup = 'removeusersfromgroup',
    emailsent = 'emailsent',
    emailprocessing = 'emailprocessing',
    emailerror = 'emailerror',
    workspacecreated = 'workspacecreated',
    workspacedeleted = 'workspacedeleted',
    foldercreated = 'foldercreated',
    filescanstarted = 'filescanstarted',
    filescanapproved = 'filescanapproved',
    filescanblocked = 'filescanblocked',
    parrequest = 'parrequest',
    parpolicy = 'parpolicy',
    parblock = 'parblock',
    parexception = 'parexception',
    parevaluationpolicy = 'parevaluationpolicy',
    parevaluationblock = 'parevaluationblock',
    parevaluationexception = 'parevaluationexception',
    parpolicylockremoved = 'parpolicylockremoved',
    purviewlabelsupdated = 'purviewlabelsupdated',
    purviewlabelsupdatefailed = 'purviewlabelsupdatefailed',
    purviewcredentialsreset = 'purviewcredentialsreset',
    purviewcredentialsupdated = 'purviewcredentialsupdated',
    bigidscan = 'bigidscan',
    smssent = 'smssent'
}

export type AccessApps = OpenOptions | 'Salesforce' | 'sharepoint';

/* eslint-disable camelcase */
interface DeleteUserDetails {
    deleted_user_id: string;
    deleted_user_email: string;
}

interface UserGroupOperationDetails {
    group_id: string;
    group_name: string;
}

export interface ModifyUserRoleDetails {
    oldRole?: string;
    newRole?: string;
    targetUserId?: string;
    targetUserEmail?: string;
    organizationId?: string;
}

export interface UserInviteDetails {
    role?: string;
}

export interface LogRecord {
    operation: Operations;
    tenant: string;
    timestamp: string;
    user: string;
    app?: AccessApps;
    details?: PolicySettingsAll | DeleteUserDetails | UserGroupOperationDetails | ModifyUserRoleDetails | UserInviteDetails;
    file_id?: string;
    file_name?: string;
    file_size?: string;
    origin_id?: string;
    owner_id?: string;
    policy_id?: string;
    policy_name?: string;
    rule?: string;
    affected_users?: string[];
    user_agent?: string;
    user_ip?: string;
    user_country?: string;
    child_id?: string;
    child_name?: string;
}
/* eslint-enable camelcase */

export class LastAuditLogQuery {
    lastNextToken?: string;
    lastPageNumber: number = 1;
    lastPageSize: number = 25;
    lastSearchedUser: string = '';
    lastSearchedFilename: string = '';
    lastSearchedFileId: string = '';
    lastSelectedOperation: string = '';
    lastFetchTime: number = new Date().getTime();

    constructor(
        lastNextToken?: string, 
        lastPageNumber?: number, 
        lastPageSize?: number, 
        lastSearchedUser?: string, 
        lastSearchedFilename?: string, 
        lastSearchedFileId?: string, 
        lastFetchTime?: number,
        lastSelectedOperation?: string,){
        this.lastNextToken = lastNextToken ?? '';
        this.lastPageNumber = lastPageNumber ?? 1;
        this.lastPageSize = lastPageSize ?? 25;
        this.lastSearchedUser = lastSearchedUser ?? '';
        this.lastSearchedFilename = lastSearchedFilename ?? '';
        this.lastSearchedFileId = lastSearchedFileId ?? '';
        this.lastFetchTime = lastFetchTime ?? new Date().getTime();
        this.lastSelectedOperation = lastSelectedOperation ?? '';
    }
}

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export type PageSize = 10 | 15 | 25 | 50;

export interface PaginationState {
    currentPage: number;
    nextPageToken: string;
    pageSize: PageSize;
}

export interface GetAuditsParams {
    page?: number;
    restRecords?: number;
}

export interface FiltersState {
    searchedUser: string;
    searchedFilename: string;
    searchedFileId: string;
    selectedOperation: Operations | '';
}

export type SelectedOperation = Operations | '';

export type FilterTypes = keyof FiltersState;

export type ChangeFilters = (filterType: FilterTypes, value: string) => void;

export interface AuditsResponse {
    results: LogRecord[];
    page: number;
    pageSize: number;
    next?: string;
}

export enum FormFields {
    searchedUser = 'searchedUser',
    selectedOperation = 'selectedOperation',
    searchedFilename = 'searchedFilename',
    searchedFileId = 'searchedFileId',
}

export interface FormFieldsChange {
    [FormFields.searchedUser]: string;
    [FormFields.searchedFilename]: string;
    [FormFields.searchedFileId]: string;
    [FormFields.selectedOperation]: SelectedOperation;
}

export interface AuditsRequestConfig {
    recordsCount: number;
    allowInParallel: boolean;
    next?: string;
}

export interface GenerateBecomeLicensedUserEmailRequestConfig {
    newLeadEmail: string;
    newLeadRealLoginEmail: string;
}
